export function getMinutesByData(time: string) {
    const [hours, minutes] = time.split(':').map(Number)

    if (isNaN(hours) || isNaN(minutes)) {
        return NaN
    }

    return hours * 60 + minutes
}